var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaArrowIosBackFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M749.125 1029.17C741.033 1029.19 733.037 1027.41 725.726 1023.94C718.414 1020.47 711.973 1015.41 706.875 1009.13L445.25 684.125C437.283 674.433 432.928 662.276 432.928 649.729C432.928 637.183 437.283 625.026 445.25 615.333L716.083 290.333C725.277 279.272 738.489 272.315 752.812 270.995C767.136 269.674 781.397 274.098 792.458 283.292C803.52 292.486 810.476 305.698 811.797 320.021C813.117 334.344 808.694 348.605 799.5 359.667L557.375 650L791.375 940.333C797.999 948.284 802.206 957.966 803.5 968.233C804.793 978.501 803.118 988.924 798.674 998.269C794.229 1007.61 787.2 1015.49 778.419 1020.97C769.638 1026.44 759.473 1029.29 749.125 1029.17Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaArrowIosBackFill);
export default __webpack_public_path__ + "static/media/eva_arrow-ios-back-fill.b9471ff63d306f6d8473f0b27b7cb4aa.svg";
export { ForwardRef as ReactComponent };